module.exports = __webpack_public_path__ + "img/pictures.67bbf8a9.svg";